
export const virtualsensortext = {
    id: "Id",
    name: "Nom",
    frequency: "Fréquence",
    group: "Entité",
    formula: "Formule",
    lastvalue: "Date de dernière valeur",
    lastrun: "Dernière valeur",
    edit: "Edition du capteur virtuel",
    delete: "Suppression du capteur virtuel",
    definition: "Définition du capteur virtuel",
    triggeredPoints: "Points déclencheurs",
    syncciteos: "Synchroniser avec l'hyperviseur",
    replacementvalues : "Valeurs de remplacement",
}
